module.exports = {
      id: "google-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "svg-sprite-6b422ea7dc08f55780ae3689062e9e73.svg#google",
      toString: function () {
        return this.url;
      }
    }